<template>
  <div class="Methylation">
    <div class="public-title">
      {{ title }}
      <span
        v-if="moduleAnnotation != ''"
        class="ts-info iconfont icon-zhu"
        style="color: #a4a9bf"
        @click="isNotes()"
      ></span>
    </div>
    <div class="show-box"></div>
    <div class="main">
      <div class="t-header">
        <span>检测项目</span>
        <span>检测结果</span>
      </div>
      <div class="t-body" v-for="item in dataList" :key="item.sort">
        <p @click="geneClick(item)">{{ item.geneName }}</p>
        <p>
          <span
            :style="{
              color: color[item.detectionResult],
              background: bgColor[item.detectionResult],
            }"
            >{{ item.detectionResult }}</span
          >
        </p>
      </div>
    </div>
    <!-- <van-loading v-if="isLoading" color="#1989fa" text-color="#0094ff"  vertical style="text-align:center;padding-bottom:50px" >加载中...</van-loading> -->
    <Empty v-if="isEmpty" />

    <!-- 注释弹框 -->
    <Notes ref="child" :notesText="notesText" />
  </div>
</template>
<script>
import { findMgmtResult } from "@/api/brain13";
import { mapState } from "vuex";
import isiOS from "@/utils/iosAn";

export default {
  props: {
    moduleAnnotation: {
      type: String,
    },
    title: {
      type: String,
      default: "甲基化检测结果",
    },
    moduleIsShow: {
      type: String,
    },
    templateIsShow: {
      type: String,
    },
    templateId: {
      type: String,
    },
  },
  data() {
    return {
      isLoading:true,
      isEmpty:false,
      dataList: [],
      color: {
        甲基化: "#FF627F",
      },
      bgColor: {
        甲基化: "#FFECEF",
      },
      notesText: {
        h1: this.title,
        p: this.moduleAnnotation,
      },
    };
  },
  computed: {
    ...mapState("embry", ["publicParams"]),
  },
  mounted() {
    setTimeout(() => {
      this.getData();
    }, 1000);
    // this.getData();
  },
  methods: {
    geneClick(item) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({
          name: "detailPopup",
          notesText: item.variationDetailVoList,
          type: "",
        });
      } else {
        window.android.JSCallNative(
          JSON.stringify({
            name: "detailPopup",
            notesText: item.variationDetailVoList,
            type: "",
          })
        );
      }
    },
    isNotes() {
      // this.$refs.child.ishow();
      if (this.$route.query.userAgent == "wxWeb") {
        this.$refs.child.ishow();
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({
          name: "notes",
          notesText: this.notesText,
          type: "",
        });
      } else {
        window.android.JSCallNative(
          JSON.stringify({
            name: "notes",
            notesText: this.notesText,
            type: "",
          })
        );
      }
    },
    async getData() {
      try {
        let { data } = await findMgmtResult({
          labOriginalSampleNo: this.publicParams.labOriginalSampleNo,
          productId: this.publicParams.productId,
          moduleId: this.templateId,

          // labOriginalSampleNo: "A19040038N",
          // productId: "fma-ctdna-825-pancancer",
          // moduleId: 38,
        });
        this.$emit('itemVal',false)
        this.isLoading= false
        this.dataList = data;
        if (data == "") {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
      } catch (error) {}
    },
  },
};
</script>

<style lang="less" scoped>
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.06) 100%
  );
  margin-bottom: 10px;
}
.public-title {
  height: 70px;
  line-height: 70px;
  font-size: 18PX;
  font-weight: 500;
  color: #2f354d;
  padding-left: 24px;
}
.Methylation {
  background: @background_color;
  border-radius: 10px;
  margin-bottom: 20px;
  .main {
    padding: 0 24px 16px;
    div {
      display: flex;
      justify-content: space-between;
    }
    .t-header {
      span {
        font-size: 15PX;
        font-weight: 500;
        color: #9095a7;
        line-height: 22px;
      }
    }
    .t-body {
      height: 48px;
      line-height: 48px;
      p {
        font-size: 15PX;
        font-weight: 500;
        color: #4b84ff;
        // &:last-child {
        //   // width: 70px;
        // }
      }
      span {
        font-size: 13px;
        font-weight: 400;
        padding: 2px 9px;
        background: #ebeff7;
        color: #5f697d;
      }
    }
  }
}
</style>
